import { app_url } from "app_config"
import Breadcrumb from "components/Common/Breadcrumb"
import React, { useEffect, useState } from "react"
import { Link, useNavigate, useParams } from "react-router-dom"
import {
  Container,
  CardBody,
  Card,
  UncontrolledAccordion,
  AccordionItem,
  AccordionHeader,
  AccordionBody,
  Col,
  Row,
} from "reactstrap"

import AllBookkeepers from "./Bookkeeper"
import AllDocumentMaster from "./Document Master"
import AllSingleItems from "../Single Item Master"
import { usePermissionData } from "AppContext"

const ClientInfoMaster = () => {
  const { tab_name } = useParams()
  const navigate = useNavigate()

  document.title = "Client Info Master | Peacock Accountants Limited"

  const { checkAccess, permissions } = usePermissionData()

  const [tabs, setTabs] = useState([])

  useEffect(() => {
    if (permissions) {
      const newTabs = []
    //   if (checkAccess(14, "view")) newTabs.push("client-type")
      if (checkAccess(15, "view")) newTabs.push("bookkeeper")
      if (checkAccess(16, "view")) newTabs.push("bookkeeping-system")
      if (checkAccess(17, "view")) newTabs.push("prefix-master")
      if (checkAccess(18, "view")) newTabs.push("document-master")

      setTabs(newTabs) // Update the state with the new array
    }
  }, [permissions])

  useEffect(() => {
    if (!tab_name && tabs.length) {
      navigate(`${app_url}master/client-info-master/${tabs[0]}`)
    }
  }, [tab_name, tabs])

  return (
    <div>
      <div className="page-content mb-5">
        <Container fluid>
          <Breadcrumb
            title={"Dashboard"}
            breadcrumbItem={"Client Info Master"}
          />
          <div>
            <Row>
              <Col md={2} className="pe-1">
                <Card>
                  <CardBody className=" rounded custom_side_nav p-2">
                    {tabs.map(tab => {
                      return (
                        <div key={tab} className="mb-2">
                          <Link
                            to={`${app_url}master/client-info-master/${tab}`}
                            className={`side_navlink text-capitalize ${
                              tab === tab_name && "bg-white fw-bold"
                            }`}
                          >
                            {tab.replaceAll("-", " ")}
                          </Link>
                        </div>
                      )
                    })}
                  </CardBody>
                </Card>
              </Col>
              <Col md={10}>
                <Card>
                  <CardBody>
                    {/* {tab_name === "client-type" && (
                      <AllSingleItems
                        api_name={"client-type"}
                        heading={"Client Type"}
                        title={"Client Type"}
                        fieldName={"clientType"}
                        module_id={14}
                      />
                    )} */}

                    {tab_name === "bookkeeper" && (
                      <AllBookkeepers module_id={15} />
                    )}

                    {tab_name === "bookkeeping-system" && (
                      <AllSingleItems
                        api_name={"bookkeeping-system"}
                        heading={"Bookkeeping System"}
                        title={"Bookkeeping System"}
                        fieldName={"bookkeepingSystem"}
                        module_id={16}
                      />
                    )}

                    {tab_name === "prefix-master" && (
                      <AllSingleItems
                        api_name={"prefix-master"}
                        heading={"Prefix Master"}
                        title={"Prefix Name"}
                        fieldName={"prefixName"}
                        module_id={17}
                      />
                    )}

                    {tab_name === "document-master" && (
                      <AllDocumentMaster module_id={18} />
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </div>
  )
}

export default ClientInfoMaster
